export default "__VITE_PUBLIC_ASSET__b0ebf5cf__"